import { Injectable } from '@angular/core';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import * as _ from 'lodash';
import { BehaviorSubject } from 'rxjs';
import { Club, Customer } from '~core/models';
import { StorageService } from '~core/services';

@UntilDestroy()
@Injectable({
  providedIn: 'root'
})
export class MergeCustomerService {
  public firstCustomerData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public castFirstCustomerData: any = this.firstCustomerData.asObservable();

  public secondCustomerData: BehaviorSubject<any> = new BehaviorSubject<any>([]);
  public castSecondCustomerData: any = this.secondCustomerData.asObservable();

  public combinedCustomer: BehaviorSubject<Customer> = new BehaviorSubject<Customer>(null);
  public castCombinedCustomer: any = this.combinedCustomer.asObservable();

  public requiredKeys = ['externalNumber', 'firstName', 'lastName', 'birthday', 'mobile', 'phone', 'searchEmail', 'addresses'];
  public triggered: boolean = false;
  public selectedClub: Club;

  constructor(private storage: StorageService,) {
    this.storage.castSelectedClub.pipe(untilDestroyed(this))
      .subscribe(club => this.selectedClub = club);
    if (this.selectedClub.isCampaiMembershipActive) {
      this.requiredKeys.push('campaiMembership');
    } else if (this.selectedClub.isCrmMembershipActive) {
      this.requiredKeys.push('membership');
    }
  }

  setTriggered(status: boolean) {
    this.triggered = status;
  }

  setFirstCustomer(firstCustomer) {
    this.firstCustomerData.next(firstCustomer);
  }

  setSecondCustomer(secondCustomer) {
    this.secondCustomerData.next(secondCustomer);
  }

  setCombinedCustomer(combinedCustomer) {
    this.combinedCustomer.next(combinedCustomer);
  }

  public isAssembledCustomerValid(): boolean {
    const data = this.combinedCustomer.getValue();
    const arr = [];

    for (const key of this.requiredKeys) {
      if (this.checkIfAnyCustomerHasValue(key)) {
        if (key === 'addresses') {
          arr.push(_.isEmpty(data?.addresses.find(el => el.type === 'standard')));
        } else {
          arr.push(_.isEmpty(data?.[key]));
        }
      }
    }
    return arr.every(el => el === false);
  }

  public checkIfAnyCustomerHasValue(key: string): boolean {
    const { firstCustomerValue, secondCustomerValue } = this.getCustomerValuesFromPath(key);
    if (key === 'addresses') {
      return this.firstCustomerData.getValue()[0].addresses.some(el => el.type === 'standard') ||
        this.secondCustomerData.getValue()[0].addresses.some(el => el.type === 'standard');
    }
    return firstCustomerValue || secondCustomerValue;
  }

  public getCustomerValuesFromPath(path: string) {
    const firstCustomerValue = _.get(this.firstCustomerData.getValue()[0], path, '');
    const secondCustomerValue = _.get(this.secondCustomerData.getValue()[0], path, '');
    return { firstCustomerValue, secondCustomerValue };
  }
}
